import {Component, DestroyRef, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslateService} from '@ngx-translate/core';
import {NzSpinComponent} from 'ng-zorro-antd/spin';
import {PolicyService} from '../../core/services/policy.service';
import {PolicyDocument} from '../policy/policy-document';
import {PolicyView} from '../policy/policy-view';

@Component({
  selector: 'app-consent-view',
  imports: [
    NzSpinComponent,
    PolicyView,
  ],
  templateUrl: './consent-view.html',
})
export class ConsentView {
  private readonly translate = inject(TranslateService);
  private readonly policyService = inject(PolicyService);
  private readonly destroyRef = inject(DestroyRef);

  readonly policy = signal<PolicyDocument | null>(null);

  constructor() {
    this.loadPolicy();
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.loadPolicy());
  }

  private loadPolicy(): void {
    this.policyService.load()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((policy) => this.policy.set(policy));
  }
}
